import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Sparkles, Coins, LogOut } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 glass" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="brand-logo">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-[#3ECF8E] to-emerald-600 grid place-items-center glow-btn">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <span className="font-display text-lg font-extrabold tracking-tight">
            Vira<span className="text-[#3ECF8E]">lyne</span>
          </span>
        </Link>

        <nav className="flex items-center gap-3">
          <Link to="/pricing" className="text-sm text-slate-300 hover:text-white transition-colors px-3 py-2" data-testid="nav-pricing">
            Tarifs
          </Link>
          {user ? (
            <>
              <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-green-500/10 border border-green-500/25" data-testid="user-credits-balance">
                <Coins className="w-4 h-4 text-[#3ECF8E]" />
                <span className="font-mono text-sm text-[#3ECF8E]">{user.credits}</span>
                <span className="text-xs text-slate-400 hidden sm:inline">crédits</span>
              </div>
              <Link to="/subscription" className="text-sm text-slate-300 hover:text-white transition-colors px-3 py-2 hidden sm:inline" data-testid="nav-subscription">
                Abonnement
              </Link>
              <Button onClick={() => navigate("/studio")} className="bg-white/10 hover:bg-white/15 text-white border border-white/15 rounded-full" data-testid="nav-studio-button">
                Studio
              </Button>
              {user.role === "admin" && (
                <Link to="/admin" className="text-sm text-green-300 hover:text-green-200 transition-colors px-3 py-2" data-testid="nav-admin">
                  Admin
                </Link>
              )}
              <button onClick={logout} className="p-2 text-slate-400 hover:text-white transition-colors" data-testid="logout-button" title="Déconnexion">
                <LogOut className="w-5 h-5" />
              </button>
            </>
          ) : (
            <Button onClick={() => navigate("/login")} className="bg-white/10 hover:bg-white/15 text-white border border-white/15 rounded-full" data-testid="nav-login-button">
              Connexion
            </Button>
          )}
        </nav>
      </div>
    </header>
  );
}
